import { Observable, BehaviorSubject, Subject } from 'rxjs';
import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class GerenciarRecadastramentoService {

  private validado = new BehaviorSubject<boolean>(false);
  private flagValidarCelular = new Subject<boolean>();

  constructor() {
  }

  setValidacao(isValid: boolean): void {
    this.validado.next(isValid);
  }

  getStatusValidacao(): Observable<boolean> {
    return this.validado.asObservable();
  }

  setFlagValidar(isValid: boolean): void {
    this.flagValidarCelular.next(isValid);
  }

  getStatusFlagValidar(): Observable<boolean> {
    return this.flagValidarCelular.asObservable();
  }

}
